import { owner } from './owner';
import { insurant } from './insurant';
import { firstCoowner } from './firstCoowner';
import { secondCoowner } from './secondCoowner';
import { car } from './car';
import { consents } from './consents';
import { cession } from './cession';
import { payment } from './payment';
import { promotionCode } from './promotionCode';

export const checkout = {
  ...owner,
  ...insurant,
  ...firstCoowner,
  ...secondCoowner,
  ...car,
  ...consents,
  ...cession,
  ...payment,
  ...promotionCode,
};
